import DateTime from "../../../vendor/luxon/src/datetime.js";
import "../../../vendor/luxon/src/duration.js";
const useDisableFuturePast = ({
  disableFuture,
  disablePast
}) => {
  const disabledFrom = disableFuture ? DateTime.now().plus({ day: 1 }).toISODate() : void 0, disabledTo = disablePast ? DateTime.now().minus({ day: 1 }).toISODate() : void 0;
  return { disabledFrom, disabledTo };
};
export {
  useDisableFuturePast
};
//# sourceMappingURL=useDisableFuturePast.js.map
